// extracted by mini-css-extract-plugin
export default {"tab-navigation":"Tab_tab-navigation__GfyYu","nav-item":"Tab_nav-item__XwO-x","nav-link":"Tab_nav-link__e5BdK","tab-pane":"Tab_tab-pane__+0XKf"};